export * from "./supportsWebCrypto";



// WEBPACK FOOTER //
// ../src/index.ts